import type { WhatsAppTemplateModel } from '../models/automation-api.models';
import { WHATSAPP_TEMPLATE_CATALOG } from './whatsapp-template.catalog';

/** Chaves de variáveis na ordem de envio ({{1}}, {{2}}, …). */
export function variableKeysFromWhatsAppTemplate(
  t: WhatsAppTemplateModel | null | undefined
): string[] {
  if (!t) return [];
  if (t.variableSlots?.length) {
    return [...t.variableSlots].sort((a, b) => a.index - b.index).map((s) => s.key);
  }
  if (t.variables?.length) return [...t.variables];
  return t.placeholders?.length ? [...t.placeholders] : [];
}

export function resolveExpectedWhatsAppVariableKeys(
  templateKey: string,
  templates?: readonly WhatsAppTemplateModel[] | null
): string[] {
  const key = templateKey.trim();
  if (!key) return [];
  const apiTpl = templates?.find((x) => x.key === key);
  if (apiTpl) return variableKeysFromWhatsAppTemplate(apiTpl);
  const cat = WHATSAPP_TEMPLATE_CATALOG.find((x) => x.key === key);
  return cat ? [...cat.placeholders] : [];
}

/**
 * Lista API carregada e templateKey não existe nem no catálogo local (template removido / inválido).
 */
export function isWhatsAppTemplateStaleOnApi(
  templateKey: string,
  templates: readonly WhatsAppTemplateModel[] | null | undefined
): boolean {
  const key = templateKey.trim();
  if (!key || !templates || templates.length === 0) return false;
  const inApi = templates.some((t) => t.key === key);
  const inCatalog = WHATSAPP_TEMPLATE_CATALOG.some((t) => t.key === key);
  return !inApi && !inCatalog;
}
